import React from "react";
import StoreItemsList from "../component/StoreItemsList";

const StoreItemsListContainer = () => (<StoreItemsList />)

export default StoreItemsListContainer;